import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { QuizzesTable } from '../QuizzesTable';
import { getQuizzes } from '../../api/getQuizzes';
import { getTableState, saveTableState } from '../QuizzesTable/utils';
import './QuizzesSection.scss';

export function QuizzesSection({ id, title, showSearch, initRowSize = 100, showSizeChanger, constantParams }) {
  const savedState = useMemo(() => getTableState(id), [id]);
  // console.log(id, savedState)
  const [isLoading, setIsLoading] = useState(true);
  const [state, setState] = useState(null);
  const draw = useRef(0);

  const load = useCallback(async (params) => {
    try {
      setIsLoading(true);

      draw.current = draw.current + 1;

      const data = await getQuizzes(constantParams, {
        ...params,
        draw: draw.current
      });

      if(data.draw >= draw.current){
        setState(data);
      }

      draw.current = data.draw;
      document.title = 'PC Quizzes – PokerCoaching.com';
    } catch(e) {
    } finally {
      setIsLoading(false);
    }
  }, [constantParams]);

  useEffect(() => {
    load({
      length: initRowSize,
      search: savedState?.search,
      column: savedState?.sort.column,
      direction: savedState?.sort.direction
    });
  }, [initRowSize, savedState, load]);

  function handleChangeTableView(params) {
    load(params);
    saveTableState(id, {
      search: params.search,
      sort: {
        column: params.column,
        direction: params.direction
      }
    });
  }

  return (
    <div className="QuizzesSection">
      <div className="QuizzesSection__head">
        <h1 className="QuizzesSection__title">{title}</h1>
        {state && (
          <span className="QuizzesSection__count">{state.recordsTotal}</span>
        )}
      </div>

      <QuizzesTable
        title={title}
        isLoading={isLoading}
        id={id}
        showSearch={showSearch}
        data={state}
        initSort={savedState?.sort}
        initSearch={savedState?.search}
        initRowSize={initRowSize}
        showSizeChanger={showSizeChanger}
        onChangeView={handleChangeTableView}
      />
    </div>
  );
}
